import api from '@/api/order'

const state = {
    items: [],
    item: {},
    pagination: null,
    drivers: [],
    warehouses: [],
    customers: [],
    myorders: [],
    orderItems: [],
    orderLoadingState: false,
}

const getters = {
    /* tasks: state => {
        return (state.orderItems || []).filter(
            x =>
                !x.deleted &&
                state.item_types.find(y => y.id === x.order_item_type_id)
                    .is_task
        )
    }, */
}

const mutations = {
    set(state, payload) {
        console.log('orders----payload', payload)
        state.items = payload
    },
    set_order(state, order) {
        const signature = order.signature1
        const order1 = { ...order }
        delete order1.signature1
        order1.signature = signature
        state.item = order1
    },
    delete(state, id) {
        let index = state.items.findIndex(x => x.id == id)
        state.items.splice(index, 1)
    },
    set_pagination(state, pag) {
        state.pagination = pag
    },
    set_drivers(state, drivers) {
        state.drivers = drivers
    },
    set_warehouses(state, warehouses) {
        state.warehouses = warehouses
    },
    set_customers(state, customers) {
        state.customers = customers
    },
    set_tasks(state, tasks) {
        state.tasks = tasks
    },
    set_order_items(state, orderItems) {
        state.orderItems = [...orderItems].map(x => {
            x.assets = x.assets.map(y => y.asset_id)
            return x
        })
    },
    SET_ORDER_LOADING_STATE(state, orderLoadingState) {
        state.orderLoadingState = orderLoadingState
    },
}

const actions = {
    /* Checkoff */
    async createCheckoff(context, { id, data }) {
        await api.createCheckoff(id, data)
        context.dispatch('fetchById', id)
    },

    async deleteCheckoff(context, { id, order_checkoff_id }) {
        await api.deleteCheckoff(id, order_checkoff_id)
        context.dispatch('fetchById', id)
    },

    async uploadOrder({ commit, state }, payload) {
        // get the response whether the reqest failed or was successful
        const result = await api
            .uploadOrder(payload)
            .then(response => response)
            .catch(error => error.response)

        let success = result.data.success
        let { data } = success == undefined ? {} : success
        if (!data) return result.data.success || result.data.error
        console.log('uploadOrder data', data)

        const orders = [...state.items]
        const idx = orders.findIndex(x => x.id === data.id)
        orders.splice(idx === -1 ? orders.length : idx, 1, data)
        commit('set', orders)

        return result.data.success
    },
    //////orderItems section
    async fetchOrderItems(context, id) {
        const result = await api.fetchOrderItems(id)
        let data = result.data.success.data
        const orderItems = data.map(x => {
            x.deleted = false
            return x
        })
        context.commit('set_order_items', orderItems)
    },

    async createTemplate(context, { id, template }) {
        const result = await api.createTemplate(id, template)
        return result.data.success.data
    },

    async updateOrderItems(context, { id, total, items }) {
        const result = await api.updateOrderItems(id, { total, items })
        const orderItems = result.data.success.data.map(x => {
            x.deleted = false
            return x
        })
        const order = { ...context.state.item }
        order.total_price = total

        context.commit('set_order_items', orderItems)
        context.commit('set_order', order)
    },

    async updateOrderItem(context, { order_id, id, item }) {
        const result = await api.updateOrderItem(order_id, id, item)
        const orderItems = result.data.success.data.map(x => {
            x.deleted = false
            return x
        })
        context.commit('set_order_items', orderItems)
    },

    async createOrderItem(context, { order_id, item }) {
        const result = await api.createOrderItem(order_id, item)
        const orderItems = result.data.success.data.map(x => {
            x.deleted = false
            return x
        })
        context.commit('set_order_items', orderItems)
    },

    async deleteOrderItem(context, { order_id, id }) {
        const result = await api.deleteOrderItem(order_id, id)
        const orderItems = result.data.success.data.map(x => {
            x.deleted = false
            return x
        })
        context.commit('set_order_items', orderItems)
    },

    ////////////orderItems section
    myorders() {
        return api
            .myorders()
            .then(result => {
                console.log({ result })
            })
            .catch(err => {
                throw err
            })
    },
    async markAsComplete(context, id) {
        await api.markAsComplete(id)
        context.dispatch('fetchById', id)
    },

    async markAsIncomplete(context, id) {
        await api.markAsIncomplete(id)
        context.dispatch('fetchById', id)
    },

    async create(context, payload) {
        const res = await api.create(payload)
        return res.data.success.data
    },

    async fetchById({ commit }, id) {
        try {
            commit('SET_ORDER_LOADING_STATE', true)
            const result = await api.fetchById(id)
            const order = result.data.success.data
            commit('set_order', order)
        } catch (err) {
            console.log('fetch err', err)
            throw err
        } finally {
            commit('SET_ORDER_LOADING_STATE', false)
        }
    },

    async fetch({ dispatch, rootState, commit }, { query, filters, page }) {
        await dispatch('itemType/fetchAll', {}, { root: true })

        const result = await api.fetch(query, filters, page)
        console.log('orders---fetch---result', result)

        let itemTypes = rootState.itemType.items
        console.log('itemTypes', itemTypes)
        let orders = result.data.success.data.data.map(o => {
            const tasks = o.items.filter(x => {
                const itemType = itemTypes.find(
                    y => y.id === x.order_item_type_id
                )
                return itemType.is_task
            })
            o.totalTasks = tasks.length
            o.completedTasks = tasks.filter(x => x.task_checked).length

            if (o.totalTasks != 0)
                o.taskCompletion = (o.completedTasks / o.totalTasks) * 100
            else o.taskCompletion = 0

            o.checked = false

            return o
        })

        commit('set', orders)
        let pag = result.data.success.data
        commit('set_pagination', {
            page: pag.current_page,
            pageSize: pag.per_page,
            total: pag.total,
        })
        // })
        // .catch(err => {
        //     throw err
        // })
    },

    async update(context, payload) {
        const resp = await api.update(payload.id, payload)
        console.log('store/order update resp', resp)
        const order = resp.data.success.data
        context.commit('set_order', order)
    },

    delete(context, id) {
        return api
            .delete(id)
            .then(() => {
                context.commit('delete', id)
            })
            .catch(err => {
                throw err
            })
    },
    bulkSetDriver(context, payload) {
        return api
            .bulkSetDriver(payload.orders, payload.driverId)
            .then(() => {})
            .catch(err => {
                throw err
            })
    },
    bulkSetWarehouse(context, payload) {
        return api
            .bulkSetWarehouse(payload.orders, payload.warehouseId)
            .then(() => {})
            .catch(err => {
                throw err
            })
    },

    bulkRelease(context, payload) {
        return api
            .bulkRelease(payload.orders)
            .then(() => {})
            .catch(err => {
                throw err
            })
    },

    bulkSetIncomplete(context, payload) {
        return api
            .bulkSetIncomplete(payload)
            .then(() => {})
            .catch(err => {
                throw err
            })
    },
    bulkDelete(context, payload) {
        return api
            .bulkDelete(payload.orders)
            .then(() => {})
            .catch(err => {
                throw err
            })
    },
    //////
    fetchDrivers(context) {
        return api.fetchDrivers().then(result => {
            context.commit('set_drivers', result.data.success.data)
        })
    },
    fetchWarehouses(context) {
        return api.fetchWarehouses().then(result => {
            context.commit('set_warehouses', result.data.success.data)
        })
    },

    //
    deleteAttachment(context, { order_id, attachment_id }) {
        return api
            .deleteAttachment(order_id, attachment_id)
            .then(() => {})
            .catch(err => {
                throw err
            })
    },
    addAttachment(context, payload) {
        try {
            return api
                .addAttachment(payload)
                .then()
                .catch(err => {
                    throw err
                })
        } catch (error) {
            console.error(error)
            throw error
        }
    },
    fetchPresigned(context, key) {
        try {
            return api
                .fetchPresigned(key)
                .then(url => {
                    return url
                })
                .catch(err => {
                    throw err
                })
        } catch (error) {
            console.error(error)
            throw error
        }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
